module.exports = __webpack_public_path__ + "static/media/3 2 '03_6872ff7f-8dd0-4dd2-85f8-66f20563e3c1.26fd3574.png";